import { resource, RequestConfig } from '../helper/resource';

/**
 * [Auth]买卖点
 */
export function queryBuyAndSellPointUsingPOST_2(
  req: InfoCodeClientDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcBuySellPoint> {
  return resource.post('/newFund/queryBuyAndSellPoint', req, config);
}

/**
 * [No Auth]各种基金基本信息
 */
export function queryFundBaseInfoUsingPOST_2(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/newFund/queryFundBaseInfo', req, config);
}

/**
 * [No Auth]基金档案外部
 */
export function queryFundInfoUsingPOST_2(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/newFund/queryFundInfo', req, config);
}

/**
 * [No Auth]基金经理
 */
export function queryFundManagerInfoUsingPOST_2(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundManagerInfoDto> {
  return resource.postNoAuth('/newFund/queryFundManagerInfo', req, config);
}

/**
 * [No Auth]基金页面类型
 */
export function queryFundPageTypeUsingPOST_3(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundPageTypeDto> {
  return resource.postNoAuth('/newFund/queryFundPageType', req, config);
}

/**
 * [No Auth]产品概要
 */
export function queryFundProfileUsingPOST_3(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultLcAnnouncement> {
  return resource.postNoAuth('/newFund/queryFundProfile', req, config);
}

/**
 * [No Auth]产品宣传图链接
 */
export function queryPublicityPictureUrlUsingPOST_2(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultstring> {
  return resource.postNoAuth('/newFund/queryPublicityPictureUrl', req, config);
}

/**
 * [No Auth]阅读文件留痕
 */
export function addFundLeaveMarksUsingPOST_2(req: LcFundLeaveMarks | void, config?: RequestConfig): Promise<void> {
  return resource.postNoAuth('/newFund/saveFundLeaveMarks', req, config);
}

/**
 * [No Auth]根据产品代码查询产品文件路径
 */
export function searchFindFileUsingPOST_2(
  req: SearchFindFileParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundFilePathVo> {
  return resource.postNoAuth('/newFund/searchFindFile', req, config);
}
